import React from "react";
import { Link } from "react-router-dom";

function PasswordNotification({ props }) {
  const { timeLeft } = props;
  return (
    <div className="verification overflow-x-hidden">
      <div className="ver-box py-12 w-4/5 lg:w-2/5">
        <div name="header " className="w-full text-center">
          <p className="header-title-bold ver-title m-0 text-2xl font-bold lg:text-3xl">
            Password Berhasil Dirubah
          </p>
          <div className="flex w-full justify-center">
            <p className="header-content ver-subtitle mt-3 w-4/5 font-semibold lg:text-sm lg:w-2/4 ">
              Password anda telah berhasil dirubah, selalu ingat password baru
              anda
            </p>
          </div>
        </div>
        <div name="image-email" className="w-full flex justify-center my-4">
          <img
            src={
              process.env.REACT_APP_BASE_URL +
              "/assets/icon/ic_password_success.svg"
            }
            alt="icon-send-password"
            className="w-auto h-28 lg:h-40"
          />
        </div>
        <div name="more info" className="flex w-full justify-center">
          <p className="header-content ver-subtitle mt-2 w-4/5 font-semibold text-center lg:text-sm lg:w-2/4 ">
            Anda akan langsung diarahkan ke halaman home dalam waktu{" "}
            <span className="text-blue-900 font-bold">{timeLeft} Detik</span>
          </p>
        </div>
        <div name="button home" className="w-full flex justify-center mt-5">
          <Link to="/">
            <button className="btn-blue w-60 p-3 focus:outline-none lg:w-96">
              <div className="text-white font-semibold lg:text-lg">
                Back to Home
              </div>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PasswordNotification;
